webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/*!***************************************************************!*\
  !*** ./node_modules/vue-svg-loader!./static/images/arrow.svg ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.4 18.66"}},[_c('title',[_v("Artboard 2")]),_c('path',{attrs:{"fill":"none","stroke":"#000","stroke-width":"2","d":"M8.7 17.16V0M16.4 9.33l-7.7 7.83L1 9.33"}})])}}};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /var/www/52artists52actions.com/src/index.js */152);


/***/ }),
/* 152 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes_route_home_vue__ = __webpack_require__(/*! ./routes/route-home.vue */ 155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_route_atlas_vue__ = __webpack_require__(/*! ./routes/route-atlas.vue */ 159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_route_artist_vue__ = __webpack_require__(/*! ./routes/route-artist.vue */ 163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_route_program_vue__ = __webpack_require__(/*! ./routes/route-program.vue */ 168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_route_about_vue__ = __webpack_require__(/*! ./routes/route-about.vue */ 172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_route_bulletin_vue__ = __webpack_require__(/*! ./routes/route-bulletin.vue */ 177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_route_tags_vue__ = __webpack_require__(/*! ./routes/route-tags.vue */ 181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes_route_not_found_vue__ = __webpack_require__(/*! ./routes/route-not-found.vue */ 185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_vue__ = __webpack_require__(/*! ./components/app.vue */ 189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_marquee_vue__ = __webpack_require__(/*! ./components/text-marquee.vue */ 194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_chyron_vue__ = __webpack_require__(/*! ./components/chyron.vue */ 198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_top_menu_vue__ = __webpack_require__(/*! ./components/top-menu.vue */ 233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_bottom_menu_vue__ = __webpack_require__(/*! ./components/bottom-menu.vue */ 237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_atlas_vue__ = __webpack_require__(/*! ./components/atlas.vue */ 241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_slider_vue__ = __webpack_require__(/*! ./components/slider.vue */ 246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_slide_vue__ = __webpack_require__(/*! ./components/slide.vue */ 264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_artist_gallery_vue__ = __webpack_require__(/*! ./components/artist-gallery.vue */ 268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_nav_items_vue__ = __webpack_require__(/*! ./components/nav-items.vue */ 272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_video_player_vue__ = __webpack_require__(/*! ./components/video-player.vue */ 276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_play_button_vue__ = __webpack_require__(/*! ./components/play-button.vue */ 280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__filters__ = __webpack_require__(/*! ./filters */ 284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__router__ = __webpack_require__(/*! ./router */ 291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_store__ = __webpack_require__(/*! ./store/store */ 293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_intersection_observer__ = __webpack_require__(/*! intersection-observer */ 298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_intersection_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_observe_visibility__ = __webpack_require__(/*! vue-observe-visibility */ 299);

































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_25_vue_observe_visibility__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_22__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_23__store_store__["a" /* default */],
  render: function render() {
    var h = arguments[0];

    return h(
      'app',
      null,
      []
    );
  }
});

window.app = app;

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */
/*!***********************************!*\
  !*** ./src/routes/route-home.vue ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_home_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./route-home.vue */ 157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50053316_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_home_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-50053316","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./route-home.vue */ 158);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-50053316","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./route-home.vue */ 156)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50053316"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50053316_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 156 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50053316","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/routes/route-home.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/route-home.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_svg_loader_static_images_arrow_svg__ = __webpack_require__(/*! vue-svg-loader!../../static/images/arrow.svg */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_svg_loader_static_images_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vue_svg_loader_static_images_arrow_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RouteHome', {
  data: function data() {
    return {
      playVideo: false
    };
  },
  components: {
    iconArrow: __WEBPACK_IMPORTED_MODULE_2__vue_svg_loader_static_images_arrow_svg___default.a
  },
  methods: {
    openArtistOverlay: function openArtistOverlay(slug) {
      this.$store.commit('openArtistOverlay', slug);
    },
    visibilityChanged: function visibilityChanged(visible, entry) {
      if (visible) this.playVideo = true;
    }
  },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('artists', ['currentArtist', 'previousArtist', 'upcomingArtist']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('site', ['excerpt', 'homeGallery']))
}));

/***/ }),
/* 158 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50053316","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-home.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"feature"},[(_vm.currentArtist)?_c('router-link',{staticClass:"image",style:(("background-image: url('" + (_vm.$options.filters.imgix(_vm.currentArtist.feature_image)) + "')")),attrs:{"tag":"div","to":("artist/" + (_vm.currentArtist.slug))}}):_vm._e()],1),_vm._v(" "),(_vm.homeGallery)?_c('div',{staticClass:"gallery__container"},[_c('artist-gallery',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChanged),expression:"visibilityChanged"}],staticClass:"gallery",attrs:{"position":"home","gallery":_vm.homeGallery,"playVideo":_vm.playVideo}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"size-large",domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.excerpt))}}),_vm._v(" "),_c('div',{staticClass:"button size-large"},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Read more "),_c('icon-arrow')],1)],1)]),_vm._v(" "),_c('div',{staticClass:"navigation"},[(_vm.upcomingArtist)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col image",style:(("background-image: url('" + (_vm.$options.filters.imgix(_vm.upcomingArtist.profile_image, { h: 480 })) + "')"))}),_vm._v(" "),_c('div',{staticClass:"col col--text"},[_c('div',{staticClass:"text size-medium"},[_vm._v("\n          Upcoming Artist:"),_c('br'),_vm._v("\n          "+_vm._s(_vm.upcomingArtist.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"button-outer"},[_c('router-link',{staticClass:"button size-small",attrs:{"to":("/artist/" + (_vm.upcomingArtist.slug))}},[_vm._v("See profile")])],1)])]):_vm._e(),_vm._v(" "),(_vm.previousArtist)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col image",style:(("background-image: url('" + (_vm.$options.filters.imgix(_vm.previousArtist.profile_image, { h: 480 })) + "')"))}),_vm._v(" "),_c('div',{staticClass:"col col--text"},[_c('div',{staticClass:"text size-medium"},[_vm._v("\n          Previous Artist:"),_c('br'),_vm._v("\n          "+_vm._s(_vm.previousArtist.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"button-outer"},[_c('router-link',{staticClass:"button size-small",attrs:{"to":("/artist/" + (_vm.previousArtist.slug))}},[_vm._v("See profile")])],1)])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 159 */
/*!************************************!*\
  !*** ./src/routes/route-atlas.vue ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_atlas_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./route-atlas.vue */ 161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243ce0c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_atlas_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-243ce0c4","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./route-atlas.vue */ 162);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-243ce0c4","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./route-atlas.vue */ 160)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-243ce0c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_atlas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243ce0c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_atlas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 160 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-243ce0c4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/routes/route-atlas.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/route-atlas.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RouteAtlas', {
  computed: {
    artists: function artists() {
      return this.$store.getters['artists/artists'];
    }
  }
}));

/***/ }),
/* 162 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243ce0c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-atlas.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.artists)?_c('atlas',{attrs:{"artists":_vm.artists}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 163 */
/*!*************************************!*\
  !*** ./src/routes/route-artist.vue ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_artist_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./route-artist.vue */ 165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d8ca18_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_artist_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-63d8ca18","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./route-artist.vue */ 167);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-63d8ca18","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./route-artist.vue */ 164)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63d8ca18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_artist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d8ca18_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_artist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 164 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63d8ca18","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/routes/route-artist.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/*!********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/route-artist.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fitvids__ = __webpack_require__(/*! fitvids */ 166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fitvids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fitvids__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RouteArtist', {
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_fitvids___default()();
  },

  watch: {
    artist: function artist(to, from) {
      if (!from && to) {
        this.$nextTick(function () {
          __WEBPACK_IMPORTED_MODULE_2_fitvids___default()();
        });
      }
    }
  },
  computed: {
    slug: function slug() {
      return this.$route.params.artist;
    },
    artist: function artist() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.getters['artists/artists'], { slug: this.slug });
    }
  }
}));

/***/ }),
/* 166 */,
/* 167 */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d8ca18","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-artist.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"contents"},[(_vm.artist)?_c('div',{attrs:{"data-artist":_vm.artist.slug}},[(_vm.artist.show_action)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"inner"},[_c('h2',{staticClass:"heading size-large"},[_vm._v(_vm._s(_vm._f("pad")(_vm.artist.num))+", "+_vm._s(_vm.artist.title))]),_vm._v(" "),_c('div',{staticClass:"details size-body"},[(_vm.artist.dates)?_c('div',[_vm._v("Dates: "+_vm._s(_vm.artist.dates))]):_c('div',[_vm._v("Dates: "+_vm._s(_vm._f("numDate")(_vm.artist.num)))]),_vm._v(" "),(_vm.artist.location)?_c('div',[_vm._v("Location: "+_vm._s(_vm.artist.location))]):_vm._e(),_vm._v(" "),(_vm.artist.commissioned_by)?_c('div',[_vm._v("Commissioned By: "+_vm._s(_vm.artist.commissioned_by))]):_vm._e(),_vm._v(" "),(_vm.artist.thanks_to)?_c('div',[_vm._v("With thanks to: "+_vm._s(_vm.artist.thanks_to))]):_vm._e(),_vm._v(" "),(_vm.artist.medium)?_c('div',[_vm._v("Medium: "+_vm._s(_vm.artist.medium))]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("Location: "),(_vm.artist.city)?_c('span',[_vm._v(_vm._s(_vm.artist.city)+",")]):_vm._e(),_vm._v(" "+_vm._s(_vm.artist.country))])])])]),_vm._v(" "),_c('div',{staticClass:"col text size-body"},[_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.artist.work))}})])]):_vm._e(),_vm._v(" "),(_vm.artist.show_action && _vm.artist.gallery && _vm.artist.gallery.length)?_c('artist-gallery',{staticClass:"gallery",attrs:{"gallery":_vm.artist.gallery}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"inner"},[(_vm.artist.show_action)?_c('div',[_c('h3',{staticClass:"size-large"},[_vm._v("Artist Information")])]):_c('div',[_c('h2',{staticClass:"size-large"},[_vm._v(_vm._s(_vm._f("pad")(_vm.artist.num))+", "+_vm._s(_vm.artist.title))]),_vm._v(" "),_c('div',{staticClass:"details size-body"},[_c('div',[_vm._v("Date: "+_vm._s(_vm._f("numDate")(_vm.artist.num)))]),_vm._v(" "),(_vm.artist.medium)?_c('div',[_vm._v("Medium: "+_vm._s(_vm.artist.medium))]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("Location: "),(_vm.artist.city)?_c('span',[_vm._v(_vm._s(_vm.artist.city)+",")]):_vm._e(),_vm._v(" "+_vm._s(_vm.artist.country))])])]),_vm._v(" "),_c('div',{staticClass:"details size-body"},[(_vm.artist.country_birth)?_c('div',[_vm._v("Born: "+_vm._s(_vm.artist.country_birth))]):_vm._e(),_vm._v(" "),(_vm.artist.lives)?_c('div',[_vm._v("Lives: "+_vm._s(_vm.artist.lives))]):_vm._e(),_vm._v(" "),(_vm.artist.identifies_as)?_c('div',[_vm._v("Identifies as: "+_vm._s(_vm.artist.identifies_as))]):_vm._e(),_vm._v(" "),(_vm.artist.language_group)?_c('div',[_vm._v("Language/Language group: "+_vm._s(_vm.artist.language_group))]):_vm._e(),_vm._v(" "),(_vm.artist.website)?_c('div',[_vm._v("Website: "+_vm._s(_vm.artist.website))]):_vm._e(),_vm._v(" "),(_vm.artist.instagram)?_c('div',[_vm._v("Instagram: "),_c('a',{attrs:{"target":"_blank","href":("https://instagram.com/" + (_vm.artist.instagram))}},[_vm._v("@"+_vm._s(_vm.artist.instagram))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col text size-body"},[_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.artist.about))}})])]),_vm._v(" "),(_vm.artist.previous_works && _vm.artist.previous_works.length)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col text size-body"},[_c('div',{staticClass:"inner"},_vm._l((_vm.artist.previous_works),function(row,n){return _c('div',{key:n,attrs:{"data-n":n}},[(row.text)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(row.text))}}):_vm._e(),_vm._v(" "),(row.image || row.video)?_c('figure',[(row.image)?_c('img',{attrs:{"src":_vm.$options.filters.imgix(row.image, { w: 1200, fit: 'max' })}}):_vm._e(),_vm._v(" "),(row.video)?_c('video-player',{attrs:{"src":row.video}}):_vm._e(),_vm._v(" "),(row.caption)?_c('figcaption',{staticClass:"size-tiny",domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(row.caption))}}):_vm._e()],1):_vm._e()])}))])]):_vm._e()],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"inner"},[_c('h2',{staticClass:"size-large"},[_vm._v("Previous Works")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/*!**************************************!*\
  !*** ./src/routes/route-program.vue ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_program_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./route-program.vue */ 170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2919ca29_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_program_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2919ca29","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./route-program.vue */ 171);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2919ca29","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./route-program.vue */ 169)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2919ca29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_program_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2919ca29_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_program_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 169 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2919ca29","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/routes/route-program.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/route-program.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RouteProgram', {
  data: function data() {
    return {
      sort: {
        field: 'num',
        reverse: false
      }
    };
  },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('artists', ['artists', 'currentArtist', 'programFeaturedArtist']), {
    sortedArtists: function sortedArtists() {
      if (!this.artists) return;

      var sortedArtists = this.artists;

      if (this.sort.field) sortedArtists = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(sortedArtists, this.sort.field);
      if (this.sort.reverse) sortedArtists = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reverse(sortedArtists);

      return sortedArtists;
    }
  })
}));

/***/ }),
/* 171 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2919ca29","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-program.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"archive"},[(_vm.currentArtist)?_c('div',{staticClass:"feature"},[_c('router-link',{staticClass:"image",style:(("background-image: url('" + (_vm.$options.filters.imgix(_vm.currentArtist.program_image || _vm.currentArtist.feature_image)) + "')")),attrs:{"tag":"div","to":("/program/artist/" + (_vm.currentArtist.slug))}})],1):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"sort-controls size-small"},[_c('div',{staticClass:"dropdown"},[_c('a',{class:{active:_vm.sort.field=='num'},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.sort.field = 'num'}}},[_vm._v("Week")]),_vm._v(" "),_c('a',{class:{active:_vm.sort.field=='title'},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.sort.field = 'title'}}},[_vm._v("Artist")]),_vm._v(" "),_c('a',{class:{active:_vm.sort.field=='country'},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.sort.field = 'country'}}},[_vm._v("Country")])]),_vm._v(" "),_c('div',{staticClass:"direction",on:{"click":function($event){$event.preventDefault();_vm.sort.reverse = !_vm.sort.reverse}}},[_c('img',{staticClass:"arrow",class:{flip:_vm.sort.reverse},attrs:{"src":"/static/images/arrow.svg"}})])]),_vm._v(" "),_c('transition-group',{staticClass:"list",attrs:{"name":"list"}},_vm._l((_vm.sortedArtists),function(artist,n){return _c('router-link',{key:artist.slug,staticClass:"card",class:{hidden:artist.hidden,current:artist.num===_vm.currentArtist.num},attrs:{"to":("/program/artist/" + (artist.slug)),"event":artist.hidden ? '' : 'click'}},[(artist.num === _vm.currentArtist.num)?_c('div',{staticClass:"current-tag"},[_vm._v("\n        Current artist\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image"},[(artist.hidden)?_c('svg',{staticClass:"screen",attrs:{"width":"100%","height":"100%"}},[_c('pattern',{attrs:{"id":"pattern","width":"6","height":"1","patternUnits":"userSpaceOnUse"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"2","height":"1"}})]),_vm._v(" "),_c('rect',{attrs:{"fill":"url(#pattern)","width":"100%","height":"100%"}})]):_vm._e(),_vm._v(" "),(artist.profile_image)?_c('img',{attrs:{"src":_vm.$options.filters.imgix(artist.feature_image, { h: 480 })}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"detail"},[(_vm.sort.field === 'num')?_c('div',[_c('div',{staticClass:"number big size-large"},[_vm._v(_vm._s(_vm._f("pad")(artist.num)))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n            "+_vm._s(artist.title)+",\n            "),(artist.city)?_c('span',[_vm._v(_vm._s(artist.city)+",")]):_vm._e(),_vm._v(" "+_vm._s(artist.country)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.sort.field === 'title')?_c('div',[_c('div',{staticClass:"title big size-large"},[_vm._v(_vm._s(artist.title))]),_vm._v(" "),_c('div',[(artist.city)?_c('span',[_vm._v(_vm._s(artist.city)+",")]):_vm._e(),_vm._v(" "+_vm._s(artist.country)+", "+_vm._s(_vm._f("pad")(artist.num)))])]):_vm._e(),_vm._v(" "),(_vm.sort.field === 'country')?_c('div',[_c('div',{staticClass:"title big size-large"},[_vm._v(_vm._s(artist.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(artist.title)+", "+_vm._s(_vm._f("pad")(artist.num)))])]):_vm._e()])])}))],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',{staticClass:"size-large"},[_vm._v("Program Archive")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 172 */
/*!************************************!*\
  !*** ./src/routes/route-about.vue ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_about_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./route-about.vue */ 175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cafff7c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_about_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2cafff7c","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./route-about.vue */ 176);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2cafff7c","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./route-about.vue */ 173)
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2cafff7c","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./route-about.vue */ 174)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cafff7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cafff7c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 173 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cafff7c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/routes/route-about.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cafff7c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/routes/route-about.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/route-about.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RouteAbout', {
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('site', ['about', 'supporters']))
}));

/***/ }),
/* 176 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cafff7c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-about.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col text size-body"},[_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.about))}})])]),_vm._v(" "),_c('div',{staticClass:"page supporters"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col size-body text supporters__text"},[_c('div',{staticClass:"kirbytext inner",domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.supporters))}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"inner"},[_c('h2',{staticClass:"size-large"},[_vm._v("52 Artists "),_c('br'),_vm._v("52 Actions")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"inner"},[_c('h2',[_vm._v("Supporters")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 177 */
/*!***************************************!*\
  !*** ./src/routes/route-bulletin.vue ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_bulletin_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./route-bulletin.vue */ 179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776aa9a3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_bulletin_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-776aa9a3","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./route-bulletin.vue */ 180);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-776aa9a3","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./route-bulletin.vue */ 178)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-776aa9a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_bulletin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776aa9a3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_bulletin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 178 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-776aa9a3","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/routes/route-bulletin.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/route-bulletin.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RouteBulletin', {
  computed: {}
}));

/***/ }),
/* 180 */
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-776aa9a3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-bulletin.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page"},[_c('div',[_vm._v("Bulletin will go here")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 181 */
/*!***********************************!*\
  !*** ./src/routes/route-tags.vue ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_tags_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./route-tags.vue */ 183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fffc31c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_tags_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-fffc31c4","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./route-tags.vue */ 184);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-fffc31c4","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./route-tags.vue */ 182)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fffc31c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_tags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fffc31c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_tags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 182 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fffc31c4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/routes/route-tags.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/route-tags.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RouteTags', {
  computed: {
    tags: function tags() {
      return this.$store.getters['site/instagramTags'];
    }
  }
}));

/***/ }),
/* 184 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fffc31c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-tags.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag,n){return _c('a',{key:n,staticClass:"tag size-large",attrs:{"target":"_blank","href":("https://www.instagram.com/explore/tags/" + tag + "/")}},[_vm._v("\n      #"+_vm._s(tag)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 185 */
/*!****************************************!*\
  !*** ./src/routes/route-not-found.vue ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_not_found_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./route-not-found.vue */ 187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5a8ba94_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_not_found_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b5a8ba94","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./route-not-found.vue */ 188);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b5a8ba94","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./route-not-found.vue */ 186)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5a8ba94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_route_not_found_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5a8ba94_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_route_not_found_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 186 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5a8ba94","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/routes/route-not-found.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/route-not-found.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RouteNotFound', {}));

/***/ }),
/* 188 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5a8ba94","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-not-found.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"message"},[_c('h2',{staticClass:"size-large"},[_vm._v("Error 404:"),_c('br'),_vm._v("Page not found")]),_vm._v(" "),_c('p',[_vm._v("The page you requested could not be found.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/*!********************************!*\
  !*** ./src/components/app.vue ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./app.vue */ 192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57696e91_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-57696e91","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./app.vue */ 193);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-57696e91","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./app.vue */ 190)
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-57696e91","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./app.vue */ 191)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57696e91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57696e91_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 190 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57696e91","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57696e91","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/app.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/*!***************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/app.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('App', {
  mounted: function mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);

    this.showRandomIdent();
    this.onRouteChange();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  },

  data: function data() {
    return {
      showIdent: false
    };
  },
  watch: {
    '$route': function $route(to, from) {
      this.onRouteChange();
    },
    lockScroll: function lockScroll(lock, from) {
      if (lock) {
        document.body.classList.add('prevent-scroll');
      } else {
        document.body.classList.remove('prevent-scroll');
      }
    }
  },
  computed: {
    pageTitle: function pageTitle() {
      return (this.$route.name || '').replace(/Artist/, '');
    },
    headerArtist: function headerArtist() {
      return this.currentArtist;
    },
    headerArtistUrl: function headerArtistUrl() {
      if (this.headerArtist) return 'artist/' + this.headerArtist.slug;
    },
    currentArtist: function currentArtist() {
      return this.$store.getters['artists/currentArtist'];
    },
    menuOut: function menuOut() {
      return this.$store.state.scrollDirection === 'down';
    },
    scrolled: function scrolled() {
      return this.$store.getters.scrolled;
    },
    lockScroll: function lockScroll() {
      return this.$store.getters.lockScroll;
    }
  },
  methods: {
    onClickCloseOverlay: function onClickCloseOverlay() {
      this.$router.replace(window.location.pathname.replace(/\/artist\/(.+)/, '') || '/');
    },
    onRouteChange: function onRouteChange() {
      var overlay = false;

      if (this.$route.matched.length) overlay = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.$route, 'matched[0].components.overlay');
      this.$store.commit('overlayOpen', overlay);
    },
    identLoaded: function identLoaded() {
      document.body.classList.add('ident-loaded');

      if (false) {
        this.showIdent = false;
      } else {
        this.identTimeout = setTimeout(function () {
          this.showIdent = false;
        }.bind(this), 4000);
      }
    },
    showRandomIdent: function showRandomIdent() {
      if (this.identTimeout) clearTimeout(this.identTimeout);

      // const idents = ['/static/images/loader-6.gif', '/static/images/loader-7.gif']
      var idents = ['/static/images/loader-4.gif', '/static/images/loader-5.gif'];

      this.showIdent = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.first(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.shuffle(idents));
    },
    hideIdent: function hideIdent() {
      if (this.identTimeout) clearTimeout(this.identTimeout);

      this.showIdent = false;
    },
    onScroll: function onScroll(event) {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      this.$store.dispatch('scrollTop', scrollTop);
    },
    onResize: function onResize(event) {
      this.$store.commit('windowHeight', window.innerHeight);
    }
  }
}));

/***/ }),
/* 193 */
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57696e91","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app.vue ***!
  \********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yield",attrs:{"data-route":_vm.$route.name}},[_c('transition',{attrs:{"name":"fade-slow"}},[(_vm.showIdent)?_c('div',{staticClass:"loader image",style:(("background-image: url('" + _vm.showIdent + "')")),on:{"click":_vm.hideIdent}},[_c('img',{staticStyle:{"opacity":"0","pointer-events":"none"},attrs:{"src":_vm.showIdent},on:{"load":_vm.identLoaded}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"menu size-small",class:{out:_vm.menuOut}},[_c('a',{staticClass:"block trigger",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$store.commit('openMenu')}}},[_vm._v("Menu")]),_vm._v(" "),(_vm.headerArtist)?_c('router-link',{staticClass:"block caption",attrs:{"append":"","to":_vm.headerArtistUrl}},[_vm._v("\n      Artist "+_vm._s(_vm._f("pad")(_vm.headerArtist.num))+"/52: "+_vm._s(_vm.headerArtist.title)),_c('span',{staticClass:"location"},[_vm._v(", "),(_vm.headerArtist.city)?_c('span',[_vm._v(_vm._s(_vm.headerArtist.city)+",")]):_vm._e(),_vm._v(" "+_vm._s(_vm.headerArtist.country))])]):_vm._e()],1),_vm._v(" "),(_vm.pageTitle !== 'home')?_c('div',{staticClass:"current-nav size-small",class:{out:_vm.menuOut}},[_vm._v(_vm._s(_vm.pageTitle))]):_vm._e(),_vm._v(" "),_c('top-menu'),_vm._v(" "),_c('div',{staticClass:"view",attrs:{"data-route":_vm.$route.name}},[_c('router-view')],1),_vm._v(" "),_c('transition',{attrs:{"name":"sheet-fade"}},[(_vm.$route.params.artist)?_c('button',{staticClass:"close-overlay size-small",on:{"click":function($event){$event.preventDefault();_vm.onClickCloseOverlay($event)}}},[_vm._v("Close")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"sheet"}},[(_vm.$route.params.artist)?_c('div',{staticClass:"overlay"},[_c('router-view',{attrs:{"name":"overlay"}})],1):_vm._e()]),_vm._v(" "),(_vm.$route.name !== 'atlas')?_c('bottom-menu'):_vm._e(),_vm._v(" "),_c('chyron',{directives:[{name:"show",rawName:"v-show",value:(['home', 'program', 'atlas'].includes(_vm.$route.name)),expression:"['home', 'program', 'atlas'].includes($route.name)"}],attrs:{"show":['home', 'program', 'atlas'].includes(_vm.$route.name),"atlas":_vm.$route.name === 'atlas'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 194 */
/*!*****************************************!*\
  !*** ./src/components/text-marquee.vue ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_text_marquee_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./text-marquee.vue */ 196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba21f14_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_marquee_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7ba21f14","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./text-marquee.vue */ 197);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7ba21f14","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./text-marquee.vue */ 195)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ba21f14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_text_marquee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba21f14_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_marquee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 195 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba21f14","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/text-marquee.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/text-marquee.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('TextMarquee', {
  props: {
    text: {
      type: String,
      required: true
    },
    speed: {
      type: Number,
      required: false,
      default: 1
    }
  },
  data: function data() {
    return {
      paused: false,
      reverse: false,
      contentWidth: 0,
      transform: null,
      clones: 0
    };
  },
  mounted: function mounted() {
    this.measure();
    this.animate();
    setInterval(this.measure, 1000);
  },

  methods: {
    visibilityChanged: function visibilityChanged(visible, entry) {
      this.paused = !visible;
    },
    measure: function measure() {
      if (this.$refs.text && !this.paused) {
        this.contentWidth = this.$refs.text.offsetWidth;
        var containerWidth = this.$el.offsetWidth;
        this.clones = this.contentWidth > containerWidth ? 1 : Math.ceil((containerWidth - this.contentWidth) / this.contentWidth) + 1;
      }
    },
    animate: function animate() {
      var ts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var delta = ts - (this.ts || 0);
      if (!this.paused) {
        var isScrolled = this.reverse ? this.offset < 0 : this.offset > this.contentWidth * -1;
        var direction = this.reverse ? -1 : 1;
        var reset = this.reverse ? this.contentWidth * -1 : 0;

        if (isScrolled) {
          this.offset -= this.speed * direction * (delta / 16);
        } else {
          this.offset = reset;
        }

        this.transform = 'translate(' + this.offset + 'px, 0)';
      }

      this.ts = ts;

      requestAnimationFrame(this.animate);
    }
  }
}));

/***/ }),
/* 197 */
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba21f14","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text-marquee.vue ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChanged),expression:"visibilityChanged"}],staticClass:"wrapper"},[_c('div',{staticClass:"container",style:({transform: _vm.transform}),on:{"mouseenter":function($event){_vm.paused = true},"mouseleave":function($event){_vm.paused = false}}},[_c('span',{ref:"text",staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_vm._l((Array.from(new Array(_vm.clones))),function(clone,i){return _c('span',{key:i,staticClass:"text clone",domProps:{"innerHTML":_vm._s(_vm.text)}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 198 */
/*!***********************************!*\
  !*** ./src/components/chyron.vue ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_chyron_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./chyron.vue */ 201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_409054e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chyron_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-409054e6","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./chyron.vue */ 232);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-409054e6","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./chyron.vue */ 199)
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-409054e6","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./chyron.vue */ 200)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-409054e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_chyron_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_409054e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chyron_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 199 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-409054e6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/chyron.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-409054e6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/chyron.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chyron.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(/*! luxon */ 202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(/*! moment */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_linkifyjs_html__ = __webpack_require__(/*! linkifyjs/html */ 222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_linkifyjs_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_linkifyjs_html__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var spacer = function spacer() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
  return Array.from(new Array(n)).map(function (_) {
    return '&nbsp;';
  }).join('');
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Chyron', {
  props: ['atlas', 'show'],
  data: function data() {
    return {
      dt: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local(),
      timeTicker: null,
      offsets: {},
      languageTickerSpeed: 1
    };
  },
  created: function created() {
    this.tick();
    this.createTimeTicker();
    setInterval(this.tick, 1000);
    setInterval(this.createTimeTicker, 1000 * 60);

    this.languageTickerSpeed = window.matchMedia('(max-width: 560px)').matches ? 1 : 2;
  },

  methods: {
    tick: function tick() {
      this.dt = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local();
    },
    createTimeTicker: function createTimeTicker() {
      var _this = this;

      this.timeTicker = this.cities.map(function (_ref) {
        var city = _ref.city,
            country = _ref.country,
            id = _ref.id,
            timezone = _ref.timezone,
            weather = _ref.weather;

        var text = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter([city, country]).join(', ');
        var _offsets$timezone = _this.offsets[timezone],
            offset = _offsets$timezone.offset,
            shortName = _offsets$timezone.shortName;

        var ts = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].utc().plus(__WEBPACK_IMPORTED_MODULE_1_luxon__["Duration"].fromObject({ minutes: offset })).toFormat('ccc T');

        if (offset > 0) {
          ts += ' GMT+' + (offset / 60).toString().padStart(2, '0');
        } else {
          ts += ' GMT' + (offset / 60).toString().padStart(2, '0');
        }

        var temp = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(weather, 'main.temp');
        var icon = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(weather, 'weather.0.icon');
        if (temp && icon) {
          var iconHtml = '<img src="/static/images/weather/' + icon + '.svg" />';
          return text + ' ' + ts + ' ' + iconHtml + ' ' + temp + '&deg;C';
        } else {
          return text + ' ' + ts;
        }
      }).join(spacer(3)) + spacer(3);
    }
  },
  watch: {
    cities: function cities(_cities) {
      var _this2 = this;

      if (_cities) {
        this.offsets = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.fromPairs(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_cities, 'timezone')), function (timezone) {
          var _dt$setZone = _this2.dt.setZone(timezone),
              offset = _dt$setZone.offset,
              offsetNameShort = _dt$setZone.offsetNameShort;

          return [timezone, { offset: offset, shortName: offsetNameShort }];
        }));

        this.createTimeTicker();
      }
    }
  },
  computed: {
    clock: function clock() {
      return this.dt.toLocaleString(__WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].TIME_WITH_SHORT_OFFSET);
    },
    cities: function cities() {
      return this.$store.state.site.cities;
    },
    languageTicker: function languageTicker() {
      var t = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.$store.state.site, 'data.translations'), 'text');
      var ticker = t.join(spacer(3)) + spacer(3);

      return ticker;
    }
  }
}));

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409054e6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chyron.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chyron size-small",class:{atlas: _vm.atlas}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col weather ticker"},[(_vm.timeTicker && _vm.show)?_c('text-marquee',{attrs:{"text":_vm.timeTicker}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col social-links"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{staticClass:"col social-link social-link-b",attrs:{"target":"_blank","href":("https://instagram.com/" + (_vm.$store.state.site.data['instagram']))}},[_vm._v("\n          @"+_vm._s(_vm.$store.state.site.data['instagram'])+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('router-link',{staticClass:"col logo logo-a",attrs:{"to":"/"}},[_vm._v("52 Artists")]),_vm._v(" "),_c('router-link',{staticClass:"col logo logo-b",attrs:{"to":"/"}},[_vm._v("52 Actions")]),_vm._v(" "),_c('div',{staticClass:"col languages ticker"},[(_vm.languageTicker && _vm.show)?_c('text-marquee',{attrs:{"text":_vm.languageTicker,"speed":_vm.languageTickerSpeed}}):_vm._e()],1)],1),_vm._v(" "),(!_vm.atlas)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col time"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.clock))]),_vm._v(" "),_c('span',{staticClass:"logo logo-a spacer"},[_vm._v("52 Artists")])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('a',{staticClass:"col social-link social-link-a",attrs:{"target":"_blank","href":"https://instagram.com/explore/tags/52Artists52Actions"}},[_vm._v("\n          #52Artists52Actions\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 233 */
/*!*************************************!*\
  !*** ./src/components/top-menu.vue ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_top_menu_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./top-menu.vue */ 235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ee5181_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_menu_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-61ee5181","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./top-menu.vue */ 236);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-61ee5181","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./top-menu.vue */ 234)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61ee5181"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_top_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ee5181_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 234 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61ee5181","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/top-menu.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/*!********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/top-menu.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('TopMenu', {
  computed: {
    menuOpen: function menuOpen() {
      return this.$store.state.menuOpen;
    }
  }
}));

/***/ }),
/* 236 */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ee5181","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/top-menu.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.menuOpen)?_c('div',{staticClass:"menu-open"},[_c('a',{staticClass:"menu-open__close size-small",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$store.commit('closeMenu')}}},[_vm._v("Close")]),_vm._v(" "),_c('nav-items',{staticClass:"size-large",attrs:{"position":"top"},on:{"click":function($event){$event.preventDefault();_vm.$store.commit('closeMenu')}}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 237 */
/*!****************************************!*\
  !*** ./src/components/bottom-menu.vue ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_bottom_menu_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./bottom-menu.vue */ 239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2043bbb2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_menu_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2043bbb2","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./bottom-menu.vue */ 240);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2043bbb2","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./bottom-menu.vue */ 238)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2043bbb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_bottom_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2043bbb2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 238 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2043bbb2","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bottom-menu.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bottom-menu.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('bottom-menu', {}));

/***/ }),
/* 240 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2043bbb2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom-menu.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-menu"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col--left text size-large"},[_c('nav',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$store.dispatch('scrollToTop')}}},[_vm._v("Return "),_c('br'),_vm._v("to top")])])]),_vm._v(" "),_c('div',{staticClass:"col text nav size-large"},[_c('nav-items',{attrs:{"position":"bottom"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/*!**********************************!*\
  !*** ./src/components/atlas.vue ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_atlas_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./atlas.vue */ 244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45623f2f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_atlas_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-45623f2f","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./atlas.vue */ 245);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-45623f2f","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./atlas.vue */ 242)
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-45623f2f","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./atlas.vue */ 243)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45623f2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_atlas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45623f2f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_atlas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 242 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45623f2f","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/atlas.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45623f2f","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/atlas.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/atlas.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//




mapboxgl.accessToken = "pk.eyJ1IjoibWF0dGxlbnoiLCJhIjoiY2pha2luMmc1Mmo5ZzJxbWhjdnRxbTUwcyJ9.3J7uNIyvOsVkUVT_ZxQY6A";

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Atlas', {
  props: ['artists'],
  data: function data() {
    return {
      map: null
    };
  },
  methods: {
    handleKeyDown: function handleKeyDown(event) {
      if (event.key === 'Meta') this.map.scrollZoom.enable();
    },
    handleKeyUp: function handleKeyUp(event) {
      if (event.key === 'Meta') this.map.scrollZoom.disable();
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('keyup', this.handleKeyUp);
  },
  mounted: function mounted() {
    var _this = this;

    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('keyup', this.handleKeyUp);
    this.map = new mapboxgl.Map({
      container: this.$refs.map,
      style: 'mapbox://styles/mapbox/light-v9',
      zoom: 1.6,
      center: [39.43060748814355, 8.091039810137929],
      attributionControl: false
    });

    this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    this.map.addControl(new mapboxgl.AttributionControl({ compact: true }));

    this.map.scrollZoom.disable();

    this.map.on('load', function () {
      _this.artists.forEach(function (artist) {
        var marker = document.createElement('div');
        marker.classList.add('atlas-marker');

        if (artist.hidden) marker.classList.add('atlas-marker--hidden');
        if (artist.current) marker.classList.add('atlas-marker--current');

        marker.addEventListener('click', function (event) {
          event.preventDefault();
          _this.$router.push('/atlas/artist/' + artist.slug);
        });

        var num = document.createElement('span');
        num.innerText = artist.num;

        marker.appendChild(num);

        var label = document.createElement('div');
        label.classList.add('atlas-marker__label');
        label.innerText = artist.title;

        marker.appendChild(label);

        new mapboxgl.Marker(marker).setLngLat(artist.coords.split(',')).addTo(_this.map);
      });
    });
  }
}));

/***/ }),
/* 245 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45623f2f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atlas.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atlas"},[_c('div',{ref:"map",staticClass:"map"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 246 */
/*!***********************************!*\
  !*** ./src/components/slider.vue ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./slider.vue */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8f05c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7e8f05c3","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./slider.vue */ 263);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7e8f05c3","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./slider.vue */ 247)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e8f05c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8f05c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 247 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e8f05c3","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/slider.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/slider.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flickity__ = __webpack_require__(/*! ../flickity */ 249);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Slider', {
  data: function data() {
    return {
      loaded: false,
      loadedCount: 0,
      loadedTotal: 0,
      initialSettle: false
    };
  },
  mounted: function mounted() {
    var flkty = new __WEBPACK_IMPORTED_MODULE_1__flickity__["a" /* default */](this.$refs.slider, {
      imagesLoaded: true,
      setGallerySize: false,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      cellAlign: 'center'
    });

    flkty.on('imagesLoadedProgress', function (img, slide) {
      if (this.$refs.slider) {
        this.loadedCount++;
        var total = Array.from(this.$refs.slider.querySelectorAll('.slide')).length;

        this.loadedTotal = total;

        if (this.loadedCount === total) this.loaded = true;
      }
    }.bind(this));

    flkty.on('staticClick', function (event, pointer, cellElem, cellIndex) {
      if (cellElem.classList.contains('is-selected')) {
        this.$emit('static-click', cellIndex);
      } else {
        if (cellIndex !== undefined) flkty.select(cellIndex);
      }
    }.bind(this));

    flkty.on('settle', function (event) {
      if (!this.initialSettle) return this.initialSettle = true;

      if (window.matchMedia('(max-width: 560px)').matches) return null;

      var otherVideos = this.$refs.slider.querySelectorAll('.slide:not(.is-selected) video');
      var selectedVideo = this.$refs.slider.querySelectorAll('.slide.is-selected video');

      Array.from(otherVideos).forEach(function (video) {
        return video.pause();
      });
      Array.from(selectedVideo).forEach(function (video) {
        return video.play();
      });
    }.bind(this));
  },

  computed: {
    loadedPercent: function loadedPercent() {
      if (this.loadedTotal) {
        return parseInt(this.loadedCount / this.loadedTotal * 100) + '%';
      } else {
        return '0%';
      }
    }
  }
}));

/***/ }),
/* 249 */
/*!*************************!*\
  !*** ./src/flickity.js ***!
  \*************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flickity_imagesloaded__ = __webpack_require__(/*! flickity-imagesloaded */ 250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flickity_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flickity_imagesloaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imagesloaded__ = __webpack_require__(/*! imagesloaded */ 149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_imagesloaded__);



__WEBPACK_IMPORTED_MODULE_0_flickity_imagesloaded___default.a.prototype.imagesLoaded = function () {
  if (!this.options.imagesLoaded) return;

  var _this = this;

  function onImagesLoadedProgress(instance, image) {
    var cell = _this.getParentCell(image.img);
    _this.cellSizeChange(cell && cell.element);
    if (!_this.options.freeScroll) _this.positionSliderAtSelected();
    _this.dispatchEvent('imagesLoadedProgress', null, [image.img, cell.element]);
  }
  __WEBPACK_IMPORTED_MODULE_1_imagesloaded___default()(this.slider).on('progress', onImagesLoadedProgress);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_flickity_imagesloaded___default.a);

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e8f05c3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-container"},[(!_vm.loaded)?_c('div',{staticClass:"loader"},[_vm._v("Loading "+_vm._s(_vm.loadedPercent))]):_vm._e(),_vm._v(" "),_c('div',{ref:"slider",staticClass:"slider",class:{loaded: _vm.loaded}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/*!**********************************!*\
  !*** ./src/components/slide.vue ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./slide.vue */ 266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_531dfe7b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-531dfe7b","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./slide.vue */ 267);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-531dfe7b","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./slide.vue */ 265)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-531dfe7b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_531dfe7b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 265 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-531dfe7b","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/slide.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/slide.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_svg_loader_static_images_arrow_svg__ = __webpack_require__(/*! vue-svg-loader!../../static/images/arrow.svg */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_svg_loader_static_images_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_svg_loader_static_images_arrow_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Slide', {
  props: ['num', 'image', 'video', 'caption', 'link'],
  components: {
    iconArrow: __WEBPACK_IMPORTED_MODULE_1__vue_svg_loader_static_images_arrow_svg___default.a
  },
  data: function data() {
    return {
      playing: false,
      dragging: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$refs.video) {
      var video = this.$refs.video;

      this.$parent.$on('static-click', function (num) {
        if (num === _this.num) _this.onClickVideo();
      });
      video.addEventListener('touchstart', function () {
        _this.dragging = false;
      });
      video.addEventListener('touchmove', function () {
        _this.dragging = true;
      });
      video.addEventListener('touchend', function () {
        if (!_this.dragging) {
          if (_this.playing) {
            video.pause();
          } else {
            video.play();
          }
        }
        _this.dragging = false;
      });
    }
  },

  methods: {
    onClickVideo: function onClickVideo() {
      if (this.playing) {
        this.$refs.video.pause();
      } else {
        this.$refs.video.play();
      }
    }
  }
}));

/***/ }),
/* 267 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-531dfe7b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide"},[_c('figure',[(_vm.link)?_c('a',{staticClass:"link",attrs:{"href":_vm.link,"target":"_blank"}},[_c('icon-arrow',{staticClass:"arrow"})],1):_vm._e(),_vm._v(" "),(_vm.video)?_c('play-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.playing),expression:"!playing"}],staticClass:"play"}):_vm._e(),_vm._v(" "),(_vm.video)?_c('video',{ref:"video",attrs:{"src":_vm.video},on:{"play":function($event){_vm.playing = true},"pause":function($event){_vm.playing = false},"ended":function($event){_vm.playing = false}}}):_vm._e(),_vm._v(" "),(_vm.image)?_c('img',{attrs:{"src":_vm._f("imgix")(_vm.image,{ h: 960 }),"draggable":"false"}}):_vm._e(),_vm._v(" "),(_vm.caption)?_c('figcaption',{staticClass:"size-tiny",domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.caption))}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 268 */
/*!*******************************************!*\
  !*** ./src/components/artist-gallery.vue ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_artist_gallery_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./artist-gallery.vue */ 270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cf4ba64_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_artist_gallery_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-9cf4ba64","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./artist-gallery.vue */ 271);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-9cf4ba64","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./artist-gallery.vue */ 269)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9cf4ba64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_artist_gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cf4ba64_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_artist_gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 269 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9cf4ba64","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/artist-gallery.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/artist-gallery.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ArtistGallery', {
  props: ['gallery', 'position', 'playVideo'],
  watch: {
    playVideo: function playVideo(to, from) {
      if (to && !from) {
        this.playFirstVideo();
      }
    }
  },
  methods: {
    playFirstVideo: function playFirstVideo() {
      var video = this.$el.querySelector('.slide.is-selected video');
      if (video) {
        video.autoplay = true;
        video.play();
      }
    }
  }
}));

/***/ }),
/* 271 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cf4ba64","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artist-gallery.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slider',{staticClass:"gallery"},_vm._l((_vm.gallery),function(item,n){return _c('slide',{key:n,staticClass:"slide",attrs:{"video":item.video,"image":item.image,"link":item.link,"caption":item.caption,"num":n}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 272 */
/*!**************************************!*\
  !*** ./src/components/nav-items.vue ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_nav_items_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./nav-items.vue */ 274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d0f728_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_items_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f3d0f728","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./nav-items.vue */ 275);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f3d0f728","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./nav-items.vue */ 273)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3d0f728"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_nav_items_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d0f728_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_items_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 273 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3d0f728","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/nav-items.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/nav-items.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_svg_loader_static_images_arrow_svg__ = __webpack_require__(/*! vue-svg-loader!../../static/images/arrow.svg */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_svg_loader_static_images_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_svg_loader_static_images_arrow_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('NavItems', {
  components: {
    iconArrow: __WEBPACK_IMPORTED_MODULE_1__vue_svg_loader_static_images_arrow_svg___default.a
  },
  props: ['position'],
  data: function data() {
    return {
      subscribeFocused: false,
      submitted: false,
      email: ''
    };
  },
  methods: {
    onSubmit: function onSubmit(event) {
      this.submitted = true;
    },
    onClickArrow: function onClickArrow(event) {
      this.$refs.button.click();
    }
  },
  computed: {
    placeholder: function placeholder() {
      if (this.subscribeFocused) {
        return 'name@email.com';
      } else {
        return 'Subscribe';
      }
    },
    links: function links() {
      var data = this.$store.state.site.data;

      return {
        instagram: data.instagram,
        youtube: data.youtube,
        vimeo: data.vimeo,
        twitter: data.twitter,
        facebook: data.facebook,
        soundcloud: data.soundcloud
      };
    }
  }
}));

/***/ }),
/* 275 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3d0f728","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav-items.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.position,on:{"click":function($event){_vm.$emit('click', $event)}}},[_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/program"}},[_vm._v("Program")])],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/atlas"}},[_vm._v("Atlas")])],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/tags"}},[_vm._v("Tags")])],1),_vm._v(" "),_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[(_vm.links.instagram)?_c('div',[_c('a',{attrs:{"target":"_blank","href":("https://instagram.com/" + (_vm.links.instagram))}},[_vm._v("Instagram")])]):_vm._e(),_vm._v(" "),(_vm.position !== 'top')?_c('div',[_c('a',{attrs:{"target":"_blank","href":"https://www.artspace.org.au"}},[_vm._v("Artspace")])]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"sub",attrs:{"action":"https://artspacesydney.createsend.com/t/j/s/egjdd/","method":"post","target":"_blank"},on:{"submit":_vm.onSubmit}},[(_vm.submitted)?_c('span',[_c('input',{key:"thanks",staticClass:"thanks",attrs:{"placeholder":"Thanks!"}})]):_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],key:"email",attrs:{"placeholder":_vm.placeholder,"name":"cm-egjdd-egjdd"},domProps:{"value":(_vm.email)},on:{"focus":function($event){_vm.subscribeFocused = true},"blur":function($event){_vm.subscribeFocused = false},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.email.length)?_c('icon-arrow',{staticClass:"arrow",nativeOn:{"click":function($event){_vm.onClickArrow($event)}}}):_vm._e()],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"button",attrs:{"type":"submit"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/*!*****************************************!*\
  !*** ./src/components/video-player.vue ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_video_player_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./video-player.vue */ 278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6fbf02a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_player_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e6fbf02a","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./video-player.vue */ 279);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-e6fbf02a","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./video-player.vue */ 277)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6fbf02a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_video_player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6fbf02a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 277 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e6fbf02a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/video-player.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/video-player.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('video-player', {
  props: ['src'],
  data: function data() {
    return {
      playing: false
    };
  },
  methods: {
    onClick: function onClick(event) {
      if (this.playing) {
        this.$refs.video.pause();
      } else {
        this.$refs.video.play();
      }
    }
  }
}));

/***/ }),
/* 279 */
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6fbf02a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-player.vue ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('play-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.playing),expression:"!playing"}],staticClass:"play"}),_vm._v(" "),_c('video',{ref:"video",attrs:{"src":_vm.src,"controls":false,"width":"100%"},on:{"play":function($event){_vm.playing = true},"pause":function($event){_vm.playing = false},"ended":function($event){_vm.playing = false},"click":_vm.onClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 280 */
/*!****************************************!*\
  !*** ./src/components/play-button.vue ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_play_button_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./play-button.vue */ 282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cb07d0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_play_button_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7cb07d0e","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./play-button.vue */ 283);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7cb07d0e","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./play-button.vue */ 281)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cb07d0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_var_www_52artists52actions_com_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_play_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cb07d0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_play_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 281 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/poi/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cb07d0e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/play-button.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/var/www/52artists52actions.com/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/play-button.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('play-button', {}));

/***/ }),
/* 283 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cb07d0e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/play-button.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"play-button",attrs:{"viewBox":"0 0 100 100"}},[_c('polygon',{attrs:{"points":"0,0 100,50 0,100","fill":"currentColor"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 284 */
/*!************************!*\
  !*** ./src/filters.js ***!
  \************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_country_list__ = __webpack_require__(/*! country-list */ 285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_country_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_country_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(/*! moment */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked__ = __webpack_require__(/*! marked */ 287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring__ = __webpack_require__(/*! querystring */ 288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_querystring__);







var countries = __WEBPACK_IMPORTED_MODULE_2_country_list___default()();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('pad', function (value) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  return ('' + value).padStart(n, '0');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('country', function (code) {
  var country = countries.getName(code);

  if (code === 'kr') {
    return 'Republic of Korea';
  } else {
    return country;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('numDate', function (num) {
  var format = 'DD.MM.YYYY';
  var week = __WEBPACK_IMPORTED_MODULE_3_moment___default()().year(2018).startOf('year').week(num);
  var weekEnd = week.clone().add(7, 'days');

  return week.format(format) + ' \u2013 ' + weekEnd.format(format);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('markdown', function (string) {
  return string && __WEBPACK_IMPORTED_MODULE_4_marked___default()(string);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('imgix', function (src) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof src === 'string') {
    return 'https://wsrv.nl?' + __WEBPACK_IMPORTED_MODULE_5_querystring___default.a.stringify(Object.assign({ url: src }, options));
  }
  return src;
});

/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/*!***********************!*\
  !*** ./src/router.js ***!
  \***********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 292);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var components = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].options.components;


var routes = [{ path: '/', component: components.RouteHome, name: 'home' }, { path: '/artist/:artist', components: { default: components.RouteHome, overlay: components.RouteArtist }, name: 'homeArtist' }, { path: '/atlas', component: components.RouteAtlas, name: 'atlas' }, { path: '/atlas/artist/:artist', components: { default: components.RouteAtlas, overlay: components.RouteArtist }, name: 'atlasArtist' }, { path: '/program', component: components.RouteProgram, name: 'program' }, { path: '/program/artist/:artist', components: { default: components.RouteProgram, overlay: components.RouteArtist }, name: 'programArtist' }, { path: '/about', component: components.RouteAbout, name: 'about' }, { path: '/about/artist/:artist', components: { default: components.RouteAbout, overlay: components.RouteArtist }, name: 'aboutArtist' }, { path: '/bulletin', component: components.RouteBulletin, name: 'bulletin' }, { path: '/bulletin/artist/:artist', components: { default: components.RouteBulletin, overlay: components.RouteArtist }, name: 'bulletinArtist' }, { path: '/tags', component: components.RouteTags, name: 'tags' }, { path: '/tags/artist/:artist', components: { default: components.RouteTags, overlay: components.RouteArtist }, name: 'tagsArtist' }, { path: '*', component: components.RouteNotFound, name: 'notFound' }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes,
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    var isOverlay = function isOverlay(route) {
      return route.matched.some(function (record) {
        return record.name.match(/Artist/);
      });
    };

    if (!isOverlay(to) && !isOverlay(from)) return { x: 0, y: 0 };
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 292 */,
/* 293 */
/*!****************************!*\
  !*** ./src/store/store.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(/*! axios */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(/*! moment */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__artists__ = __webpack_require__(/*! ./artists */ 294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__site__ = __webpack_require__(/*! ./site */ 297);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    site: __WEBPACK_IMPORTED_MODULE_6__site__["a" /* default */], artists: __WEBPACK_IMPORTED_MODULE_5__artists__["a" /* default */]
  },
  state: {
    menuOpen: false,
    overlayOpen: false,
    scrollDirection: null,
    scrollTop: 0,
    artists: null,
    windowHeight: window.innerHeight
  },
  actions: {
    scrollToTop: function scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollTop: function scrollTop(_ref, _scrollTop) {
      var state = _ref.state,
          commit = _ref.commit;

      if (_scrollTop > 0 && _scrollTop > state.scrollTop) {
        commit('scrollDirection', 'down');
      } else {
        commit('scrollDirection', 'up');
      }
      commit('scrollTop', _scrollTop);
    }
  },
  mutations: {
    scrollTop: function scrollTop(state, _scrollTop2) {
      state.scrollTop = _scrollTop2;
    },
    scrollDirection: function scrollDirection(state, _scrollDirection) {
      state.scrollDirection = _scrollDirection;
    },
    openMenu: function openMenu(state) {
      state.menuOpen = true;
    },
    closeMenu: function closeMenu(state) {
      state.menuOpen = false;
    },
    windowHeight: function windowHeight(state, _windowHeight) {
      state.windowHeight = _windowHeight;
    },
    overlayOpen: function overlayOpen(state, _overlayOpen) {
      state.overlayOpen = _overlayOpen;
    }
  },
  getters: {
    scrolled: function scrolled(state) {
      return state.scrollTop > state.windowHeight;
    },
    lockScroll: function lockScroll(state) {
      return state.menuOpen || state.overlayOpen;
    }
  }
});

store.dispatch('site/fetch');
store.dispatch('site/fetchInstagram');
store.dispatch('site/fetchCities');
store.dispatch('artists/fetch');

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 294 */
/*!******************************!*\
  !*** ./src/store/artists.js ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    artists: null
  },
  actions: {
    fetch: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
        var state = _ref.state,
            commit = _ref.commit;

        var _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://52artists52actions.com/kirby" + '/api/artists.php');

              case 2:
                _ref3 = _context.sent;
                data = _ref3.data;

                commit('receiveArtists', data);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x) {
        return _ref2.apply(this, arguments);
      }

      return fetch;
    }()
  },
  mutations: {
    receiveArtists: function receiveArtists(state, artists) {
      state.artists = artists;
    }
  },
  getters: {
    artists: function artists(state, getters, rootState, rootGetters) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(state.artists, function (artist, n) {
        artist.current = n === getters.currentArtistIndex;
        artist.hidden = n > getters.currentArtistIndex + 1;
        artist.num = parseInt(artist.num);
        return artist;
      });
    },
    currentArtist: function currentArtist(state, getters, rootState, rootGetters) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(getters.artists, getters.currentArtistIndex);
    },
    currentArtistIndex: function currentArtistIndex(state, getters, rootState, rootGetters) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(state.artists, { slug: rootGetters['site/currentArtist'] });
    },
    previousArtist: function previousArtist(state, getters) {
      if (getters.currentArtist) return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(getters.artists, getters.currentArtistIndex - 1);
    },
    upcomingArtist: function upcomingArtist(state, getters) {
      if (getters.currentArtist) return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(getters.artists, getters.currentArtistIndex + 1);
    }
  }
});

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */
/*!***************************!*\
  !*** ./src/store/site.js ***!
  \***************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(/*! moment */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    data: {},
    instagram: {},
    cities: []
  },
  actions: {
    fetch: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
        var state = _ref.state,
            commit = _ref.commit;

        var _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://52artists52actions.com/kirby" + '/api/site.php');

              case 2:
                _ref3 = _context.sent;
                data = _ref3.data;


                commit('receiveData', data);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x) {
        return _ref2.apply(this, arguments);
      }

      return fetch;
    }(),
    fetchInstagram: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit;

        var _ref6, data;

        return __WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://52artists52actions.com/kirby" + '/api/instagram.php');

              case 2:
                _ref6 = _context2.sent;
                data = _ref6.data;


                commit('receiveInstagram', data);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchInstagram(_x2) {
        return _ref5.apply(this, arguments);
      }

      return fetchInstagram;
    }(),
    fetchCities: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref7) {
        var state = _ref7.state,
            commit = _ref7.commit;

        var _ref9, data;

        return __WEBPACK_IMPORTED_MODULE_0__var_www_52artists52actions_com_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://52artists52actions.com/kirby" + '/api/cities.php');

              case 2:
                _ref9 = _context3.sent;
                data = _ref9.data;


                commit('receiveCities', data);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchCities(_x3) {
        return _ref8.apply(this, arguments);
      }

      return fetchCities;
    }()
  },
  mutations: {
    receiveData: function receiveData(state, data) {
      state.data = data;
    },
    receiveInstagram: function receiveInstagram(state, data) {
      state.instagram = data;
    },
    receiveCities: function receiveCities(state, data) {
      state.cities = data;
    }
  },
  getters: {
    currentArtist: function currentArtist(state) {
      return state.data.current_artist;
    },
    about: function about(state) {
      return state.data.about;
    },
    excerpt: function excerpt(state) {
      return state.data.excerpt;
    },
    supporters: function supporters(state) {
      return state.data.supporters;
    },
    instagramTags: function instagramTags(state) {
      var excludes = (state.data.exclude_tags || '').split('\n').map(function (tag) {
        return tag.replace('#', '').toLowerCase();
      });

      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.flatten(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toArray(state.instagram), 'tags'))), function (tag) {
        return !excludes.includes(tag.toLowerCase());
      });
    },
    homeGallery: function homeGallery(state, getters) {
      return state.data.gallery && state.data.gallery.length && state.data.gallery;
    },
    instagramGallery: function instagramGallery(state, getters, rootState, rootGetters) {
      var media = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toArray(state.instagram);

      var excludes = (state.data.exclude_home || '').split('\n').map(function (tag) {
        return tag.replace('#', '').toLowerCase();
      });

      var filteredMedia = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(media, function (item) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.intersection(item.tags.map(function (tag) {
          return tag.toLowerCase();
        }), excludes).length === 0;
      });

      var currentArtist = rootGetters['artists/currentArtist'];

      if (currentArtist) {
        var currentMedia = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(filteredMedia, function (item) {
          if (currentArtist) {
            if (currentArtist.hashtag) {
              return item.tags.map(function (tag) {
                return tag.toLowerCase();
              }).includes(currentArtist.hashtag.replace('#', '').toLowerCase());
            } else {
              return item.caption.text.match('@' + currentArtist.instagram);
            }
          }
        });

        var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reverse(currentMedia), function (item) {
          return {
            image: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(item, 'images.standard_resolution.url'),
            video: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(item, 'videos.standard_resolution.url')
          };
        });

        return results;
      }
    }
  }
});

/***/ })
],[151]);


// WEBPACK FOOTER //
// client.9cf8a869.js